import { render, staticRenderFns } from "./town-hall.vue?vue&type=template&id=38a49cee&scoped=true&"
import script from "./town-hall.vue?vue&type=script&lang=js&"
export * from "./town-hall.vue?vue&type=script&lang=js&"
import style0 from "./town-hall.vue?vue&type=style&index=0&id=38a49cee&lang=scss&scoped=true&"
import style1 from "./town-hall.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a49cee",
  null
  
)

export default component.exports